import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { CSSProperties, forwardRef, HTMLAttributes } from "react";
import classes from "./aspect-ratio.module.css";

export type AspectRatioProps = HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean;
  ratio: number | "auto";
};

export const AspectRatio = forwardRef<HTMLDivElement, AspectRatioProps>(
  ({ asChild, className, ratio, style, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";

    const ratioStyle =
      ratio === "auto"
        ? {
            paddingTop: 0,
            height: "100%",
          }
        : { "--aspect-ratio": `${(1 / ratio) * 100}%` };

    return (
      <Comp
        ref={ref}
        className={clsx(classes.root, className)}
        style={
          {
            ...ratioStyle,
            ...style,
          } as CSSProperties
        }
        {...props}
      />
    );
  },
);

AspectRatio.displayName = "AspectRatio";
